<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-images"></i>
        <div class="mg-l-20">
          <h4>{{ $t("product.商品相册管理") }}</h4>
        </div>
      </div>
      <div class="tx-right d-flex align-items-center">
        <div class="mg-r-15">
          <p class="">
            {{ $t("product.您的相册空间享有") }}{{ maxSpace
            }}{{ $t("product.容量，已使用") }}{{ size }}MB
          </p>
          <div
            class="progress"
            style="
              line-height: 24px;
              height: 24px;
              background: #fff;
              border: 1px solid #ccc;
              position: relative;
              justify-content: center;
            "
          >
            <div
              style="
                line-height: 24px;
                height: 24px;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
              "
              class="bg-info progress-bar progress-bar-lg"
              :style="{
                right: 100 - ((size / maxSpace) * 100).toFixed(2) + '%',
              }"
            ></div>
            <span style="position: relative; z-index: 1; color: #000"
              >{{ size }}MB / {{ maxSpace }}</span
            >
            <a
              v-if="
                userInfo.setSupplierAlbum != 1 &&
                isSysRights('PayRecord.getAlbumPayConfig')
              "
              href="javascript:;"
              class="tx-info mg-l-15"
              @click="openSet"
              >{{ $t("product.立即升级容量") }}</a
            >
          </div>
        </div>
        <button
          v-if="isSysRights('SupplierAlbum.uploadAlbum')"
          class="mg-r-10 btn btn-success"
          type="button"
          @click="openUpload('pic')"
        >
          {{ $t("product.上传图片") }}
        </button>
        <button
          v-if="
            !$root.$children[0].userInfo.rootUrl &&
            isSysRights('SupplierMall.getShareUrl')
          "
          class="mg-r-10 btn btn-primary"
          type="button"
          @click="shareAlbum"
        >
          {{ $t("product.分享相册") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('status')"
        >
          {{ $t("product.状态：") }}
          <span class="mg-r-10">{{ $t($dict.imgsStatus[keyStatus]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
      <div class="clear-key">
        <a
          v-show="keyType"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('type')"
        >
          {{ $t("product.类型：") }}
          <span class="mg-r-10">{{ $t($dict.imgsType[keyType]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
      <div class="clear-key">
        <a
          v-show="keyName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('name')"
        >
          {{ $t("product.相册名称：") }}
          <span class="mg-r-10">{{ keyName }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyName", "keyStatus", "keyType", "keyClickType", "keyName", "size"],
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      maxSpace: "",
    };
  },
  created() {
    if (this.userInfo.setSupplierAlbum == 1) {
      if (Number(this.userInfo.albumSize) == 0) {
        this.maxSpace = this.$t("product.无限制");
      } else {
        this.maxSpace = Number(this.userInfo.albumSize) * 1024 + "MB";
      }
    } else {
      if (
        this.userInfo.vipInfoJson &&
        this.userInfo.vipInfoJson.albumInfo &&
        this.userInfo.vipInfoJson.albumInfo.data &&
        this.userInfo.vipInfoJson.albumInfo.data.size
      ) {
        this.maxSpace =
          Number(this.userInfo.vipInfoJson.albumInfo.data.size) * 1024 + "MB";
      } else {
        this.maxSpace = 0 + "MB";
      }
    }
  },
  methods: {
    openUpload(type) {
      this.$emit("openUpload", type);
    },
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    setWatermark() {
      this.$emit("setWatermark");
    },
    shareAlbum() {
      this.$emit("shareAlbum");
    },
    openSet() {
      this.$emit("openSet");
    },
  },
};
</script>